import { rHandler } from '@/plugins/RHandler';
import { apiService } from '@/services/APIService';
import { objectsRHandler, DEFAULT_PARAMS } from '@/utils/objectsRHandler';

import Journal from '../list/journal';
import JournalExpertise from '../list/journal-expertise';

const API_PATH = 'poll-journals';
const API_PATH_FAKE = 'poll-journals/fake';

export const JournalManager = {
  objects: objectsRHandler(API_PATH, Journal),
  // у журналов поиск фейковых(внешних) по is_fake_poll или is_poll_fake
  fake: objectsRHandler(API_PATH_FAKE, Journal),

  expertises({ params } = DEFAULT_PARAMS) {
    return rHandler(
      apiService.get(`${API_PATH}-expertises`, params),
      (response) => ({
        response,
        items: response.data.data.map((i) => new JournalExpertise(i, `${API_PATH}-expertises`)),
      }),
      (error) => ({ error }),
    );
  },
};
